export default __webpack_public_path__ + "EUs_HDS.html";